import PhoneInput from 'react-phone-input';
import utils from 'helpers/utils';

class ExtendedPhoneInput extends PhoneInput {
    componentWillReceiveProps(nextProps) {
        if (nextProps.value && nextProps.value !== this.state.formattedNumber) {
            this.updateFormattedNumber(nextProps.value);
        }

        if (nextProps.defaultCountry && nextProps.defaultCountry !== this.state.defaultCountry) {
            this.updateDefaultCountry(nextProps.defaultCountry);
        }
    }

    updateFormattedNumber(number) {
        let inputNumber = number.replace(/\D/g, '');
        let selectedCountry = this.guessSelectedCountry(inputNumber.substring(0, 6), this.state.onlyCountries, this.state.defaultCountry);
        let formattedNumber = this.formatNumber(inputNumber, selectedCountry.format);

        /*
         * If inputNumber does not start with '+', then use default country's dialing prefix.
         */
        if (!~number.indexOf('+')) {
            const selectedCountryGuess = utils.find(this.state.onlyCountries, (country) => {
                return country.iso2 === this.state.defaultCountry;
            });

            const dialCode = selectedCountryGuess && !~inputNumber.indexOf(selectedCountryGuess.dialCode) ? selectedCountryGuess.dialCode : '';

            selectedCountry = selectedCountryGuess;
            formattedNumber = this.formatNumber(dialCode + inputNumber, selectedCountryGuess ? selectedCountryGuess.format : null);
        }

        this.setState({
            selectedCountry: selectedCountry,
            formattedNumber: formattedNumber,
        });
    }

    handleKeydown(event) {
        let keys = {
            A: 65,
            DOWN: 40,
            ENTER: 13,
            ESC: 27,
            LEFT: 37,
            PLUS: 43,
            RIGHT: 39,
            SPACE: 32,
            UP: 38,
            Z: 90,
        };

        if (!this.state.showDropDown) {
            return;
        }

        // IE hack
        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        const _moveHighlight = (direction) => {
            this.setState({
                highlightCountryIndex: this._getHighlightCountryIndex(direction),
            }, () => {
                this.scrollTo(this.getElement(this.state.highlightCountryIndex), true);
            });
        };

        switch (event.which) {
            case keys.DOWN:
                _moveHighlight(1);
                break;
            case keys.UP:
                _moveHighlight(-1);
                break;
            case keys.ENTER:
                this.handleFlagItemClick(this.state.onlyCountries[this.state.highlightCountryIndex], event);
                break;
            case keys.ESC:
                this.setState({ showDropDown: false }, this._cursorToEnd);
                break;
            default:
                if ((event.which >= keys.A && event.which <= keys.Z) || event.which === keys.SPACE) {
                    this.setState({
                        queryString: this.state.queryString + String.fromCharCode(event.which),
                    }, this.state.debouncedQueryStingSearcher);
                }
        }
    }
}

export default ExtendedPhoneInput;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/MobianPhoneInput/ReactPhoneInput.js